import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";
import { formatDatetime } from "data/helpers/dates";

export const VoucherActions: React.FC = (props: any) => {
  const {
    setShowAdminModal,
    setAdminData,
    setCloseData,
    setShowCloseModal,
    role,
    data,
  } = props;

  return (
    <div className="fuelops__grid-actions">
      {role === "4" && (
        <span
          className="fuelops__grid-action-item"
          onClick={() => {
            console.log("Admin Data:", {
              ...data,
              changeddate: data.changeddate
                ? formatDatetime(data.changeddate)
                : formatDatetime(data.createddate),
            });

            setAdminData({
              ...data,
              changeddate: data.changeddate
                ? formatDatetime(data.changeddate)
                : formatDatetime(data.createddate),
            });
            setShowAdminModal(true);
          }}
        >
          <FontAwesomeIcon icon={faPencilAlt} fixedWidth size="lg" />
        </span>
      )}
      {data.status !== "F" && (
        <span
          className="fuelops__grid-action-item"
          onClick={() => {
            console.log("Close Data:", {
              ...data,
            });
            setCloseData({ ...data });
            setShowCloseModal(true);
          }}
        >
          <FontAwesomeIcon icon={faClipboardCheck} fixedWidth size="lg" />
        </span>
      )}
    </div>
  );
};
